/**
 * Buggino – product comparison. Up to three products from the collection
 * grid (snippet product-card with show_compare) are kept in sessionStorage
 * and compared in a <dialog> table of the 15 datasheet fields.
 */
(function () {
  'use strict';

  const MAX = 3;
  const STORAGE_KEY = 'buggino:compare';

  const bar = document.querySelector('[data-compare-bar]');
  const dialog = document.querySelector('[data-compare-dialog]');
  if (!bar || !dialog) return;

  const itemsNode = bar.querySelector('[data-compare-items]');
  const openButton = bar.querySelector('[data-compare-open]');
  const clearButton = bar.querySelector('[data-compare-clear]');
  const hint = bar.querySelector('[data-compare-hint]');
  const tableWrap = dialog.querySelector('[data-compare-table]');

  let labels = { fields: {} };
  try {
    labels = JSON.parse(document.querySelector('[data-compare-labels]').textContent);
  } catch (error) {
    labels = { fields: {}, price: 'Preis', remove: 'Entfernen', max_reached: '', empty: '' };
  }

  function load() {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function save(items) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* storage unavailable */
    }
  }

  let selected = load();

  function dataForCard(card) {
    const node = card.querySelector('[data-compare-data]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function syncCheckboxes() {
    const ids = selected.map((item) => String(item.id));
    document.querySelectorAll('[data-compare-toggle]').forEach((checkbox) => {
      checkbox.checked = ids.includes(checkbox.value);
      checkbox.disabled = !checkbox.checked && selected.length >= MAX;
    });
  }

  function renderBar() {
    itemsNode.innerHTML = '';
    selected.forEach((item) => {
      const chip = document.createElement('span');
      chip.className = 'compare-bar__item';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 28;
        img.height = 28;
        img.loading = 'lazy';
        chip.appendChild(img);
      }
      chip.appendChild(document.createTextNode(item.title));
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'compare-bar__remove';
      remove.setAttribute('aria-label', `${labels.remove}: ${item.title}`);
      remove.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
      remove.addEventListener('click', () => removeItem(item.id));
      chip.appendChild(remove);
      itemsNode.appendChild(chip);
    });
    bar.dataset.visible = selected.length > 0 ? 'true' : 'false';
    openButton.disabled = selected.length < 2;
    if (hint) hint.textContent = selected.length >= MAX ? labels.max_reached : hint.dataset.default || hint.textContent;
  }

  function update() {
    save(selected);
    syncCheckboxes();
    renderBar();
  }

  function addItem(data) {
    if (!data || selected.length >= MAX) return;
    if (selected.some((item) => String(item.id) === String(data.id))) return;
    selected.push(data);
    update();
    if (window.Buggino && window.Buggino.announce) window.Buggino.announce(`${data.title} – ${labels.fields.type || ''}`.trim());
  }

  function removeItem(id) {
    selected = selected.filter((item) => String(item.id) !== String(id));
    update();
    if (dialog.open) renderTable();
    if (dialog.open && selected.length < 2) closeDialog();
  }

  function cell(text) {
    const td = document.createElement('td');
    td.textContent = text && String(text).trim() ? text : '–';
    return td;
  }

  function renderTable() {
    tableWrap.innerHTML = '';
    if (!selected.length) {
      const p = document.createElement('p');
      p.className = 'muted';
      p.textContent = labels.empty;
      tableWrap.appendChild(p);
      return;
    }

    const table = document.createElement('table');
    table.className = 'compare-table';

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    headRow.appendChild(document.createElement('th'));
    selected.forEach((item) => {
      const th = document.createElement('th');
      th.scope = 'col';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 96;
        img.height = 96;
        img.loading = 'lazy';
        th.appendChild(img);
      }
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      th.appendChild(link);
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');
    const priceRow = document.createElement('tr');
    const priceHead = document.createElement('th');
    priceHead.scope = 'row';
    priceHead.textContent = labels.price;
    priceRow.appendChild(priceHead);
    selected.forEach((item) => priceRow.appendChild(cell(item.price)));
    tbody.appendChild(priceRow);

    Object.keys(labels.fields).forEach((key) => {
      const row = document.createElement('tr');
      const th = document.createElement('th');
      th.scope = 'row';
      th.textContent = labels.fields[key];
      row.appendChild(th);
      selected.forEach((item) => row.appendChild(cell(item.fields ? item.fields[key] : '')));
      tbody.appendChild(row);
    });
    table.appendChild(tbody);
    tableWrap.appendChild(table);
  }

  function openDialog() {
    renderTable();
    if (window.Buggino && window.Buggino.openDialog) window.Buggino.openDialog(dialog, openButton);
    else dialog.showModal();
  }

  function closeDialog() {
    if (window.Buggino && window.Buggino.closeDialog) window.Buggino.closeDialog(dialog);
    else dialog.close();
  }

  function init() {
    if (hint) hint.dataset.default = hint.textContent;

    document.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-compare-toggle]');
      if (!checkbox) return;
      const card = checkbox.closest('[data-product-card]');
      if (checkbox.checked) {
        const data = dataForCard(card);
        if (!data || selected.length >= MAX) {
          checkbox.checked = false;
          return;
        }
        addItem(data);
      } else {
        removeItem(checkbox.value);
      }
    });

    openButton.addEventListener('click', openDialog);
    clearButton.addEventListener('click', () => {
      selected = [];
      update();
    });
    dialog.querySelector('[data-compare-close]').addEventListener('click', closeDialog);
    if (window.Buggino && window.Buggino.bindBackdropClose) window.Buggino.bindBackdropClose(dialog);

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
